import MascotLoadingOverlay from "./MascotLoadingOverlay";

export default function DetailSkeleton({ tabCount = 5, sectionRows = [4, 3] }) {
  return (
    <div className="px-0 sm:px-4 sm:py-2 h-[calc(100vh-64px)] sm:h-[calc(100vh-16px)] overflow-hidden relative">
      {/* Skeleton background */}
      <div className="bg-white sm:rounded-2xl sm:shadow-lg sm:border sm:border-gray-200 overflow-hidden flex flex-col h-full animate-pulse opacity-40 pointer-events-none">
        {/* Header Skeleton */}
        <div className="bg-gradient-to-r from-slate-50 via-blue-50 to-indigo-50 px-3 py-2.5 sm:px-5 sm:py-4 border-b border-gray-200 shrink-0">
          <div className="flex items-center gap-2.5 sm:gap-4">
            <div className="w-8 h-8 sm:w-9 sm:h-9 bg-gray-200 rounded-lg sm:rounded-xl" />
            <div className="hidden sm:block w-11 h-11 bg-gray-200 rounded-xl" />
            <div className="flex-1">
              <div className="h-4 sm:h-5 w-36 bg-gray-200 rounded mb-1.5" />
              <div className="h-3 w-24 bg-gray-100 rounded" />
            </div>
            <div className="flex flex-col items-end gap-1.5">
              <div className="h-6 w-16 bg-gray-200 rounded-lg" />
              <div className="h-6 w-14 bg-gray-200 rounded-lg" />
            </div>
          </div>
        </div>

        {/* Tab Skeleton */}
        {tabCount > 0 && (
          <div className="flex overflow-x-auto scrollbar-hide px-2 py-1.5 sm:p-2 gap-2 sm:gap-1.5 border-b border-gray-200 shrink-0">
            {Array.from({ length: tabCount }).map((_, i) => (
              <div
                key={i}
                className="shrink-0 sm:flex-1 py-2.5 sm:py-2 px-4 sm:px-3 flex items-center justify-center gap-2"
              >
                <div className="w-4 h-4 bg-gray-200 rounded" />
                <div className="h-3.5 w-12 bg-gray-200 rounded" />
              </div>
            ))}
          </div>
        )}

        {/* Content Skeleton */}
        <div className="flex-1 p-3 sm:p-4 space-y-3 overflow-y-auto bg-gray-50/40">
          {sectionRows.map((count, sIdx) => (
            <div
              key={sIdx}
              className="bg-white rounded-xl border border-gray-200 p-4 sm:p-5"
            >
              <div className="h-3 w-28 bg-gray-200 rounded mb-3" />
              <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
                {Array.from({ length: count }).map((_, i) => (
                  <div
                    key={i}
                    className="bg-slate-50 rounded-xl p-3 sm:p-4 border border-gray-200"
                  >
                    <div className="h-2.5 w-16 bg-gray-200 rounded mb-2" />
                    <div className="h-3.5 w-24 bg-gray-200 rounded" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <MascotLoadingOverlay />
    </div>
  );
}
